import { render, staticRenderFns } from "./access-facebook-effect.vue?vue&type=template&id=a720363c&scoped=true"
import script from "./access-facebook-effect.vue?vue&type=script&lang=js"
export * from "./access-facebook-effect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a720363c",
  null
  
)

export default component.exports